import { useEffect, useState } from "react"
import axios from "axios"
import { Link, useNavigate } from "react-router-dom"
import { Bounce, toast } from "react-toastify"
import { baseUrl } from "../../config/baseUrl"

const INITIAL_FORM = {
  email: "",
  otp: "",
  newPassword: "",
  confirmPassword: "",
}

export default function ForgotPassword() {
  const navigate = useNavigate()
  const token = localStorage.getItem("token")
  const [step, setStep] = useState("email")
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [loadingAction, setLoadingAction] = useState("")
  const [formVal, setFormVal] = useState(INITIAL_FORM)

  useEffect(() => {
    if (token) {
      navigate("/")
    }
  }, [navigate, token])

  const changeHandler = (e) => {
    const { name, value } = e.target
    setFormVal((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const sendOtp = async (e, isResend = false) => {
    if (e?.preventDefault) {
      e.preventDefault()
    }

    if (!formVal.email.trim()) {
      toast.error("Please enter your email address", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
        transition: Bounce,
      })
      return
    }

    try {
      setLoadingAction(isResend ? "resend" : "send")
      const response = await axios.post(`${baseUrl}/admin-user/forgot-password`, {
        email: formVal.email.trim(),
      })

      if (response?.data?.status) {
        setStep("otp")
        toast.success(response?.data?.message || "OTP sent successfully", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        })
      } else {
        toast.error(response?.data?.message || "Failed to send OTP", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        })
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to send OTP. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        }
      )
    } finally {
      setLoadingAction("")
    }
  }

  const verifyOtp = async (e) => {
    e.preventDefault()

    if (!formVal.otp.trim()) {
      toast.error("Please enter the OTP sent to your email", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
        transition: Bounce,
      })
      return
    }

    try {
      setLoadingAction("verify")
      const response = await axios.post(`${baseUrl}/admin-user/verify-reset-otp`, {
        email: formVal.email.trim(),
        otp: formVal.otp.trim(),
      })

      if (response?.data?.status) {
        setStep("reset")
        toast.success(response?.data?.message || "OTP verified successfully", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        })
      } else {
        toast.error(response?.data?.message || "Invalid OTP", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        })
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "OTP verification failed. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        }
      )
    } finally {
      setLoadingAction("")
    }
  }

  const resetPassword = async (e) => {
    e.preventDefault()

    if (!formVal.newPassword || !formVal.confirmPassword) {
      toast.error("Please enter and confirm your new password", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
        transition: Bounce,
      })
      return
    }

    if (formVal.newPassword.length < 6) {
      toast.error("New password must be at least 6 characters long", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
        transition: Bounce,
      })
      return
    }

    if (formVal.newPassword !== formVal.confirmPassword) {
      toast.error("Passwords do not match", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
        transition: Bounce,
      })
      return
    }

    try {
      setLoadingAction("reset")
      const response = await axios.post(`${baseUrl}/admin-user/reset-password`, {
        email: formVal.email.trim(),
        otp: formVal.otp.trim(),
        newPassword: formVal.newPassword,
      })

      if (response?.data?.status) {
        toast.success(response?.data?.message || "Password reset successfully", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        })
        setFormVal(INITIAL_FORM)
        navigate("/login")
      } else {
        toast.error(response?.data?.message || "Failed to reset password", {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        })
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Password reset failed. Please try again.",
        {
          position: "top-right",
          autoClose: 3000,
          theme: "light",
          transition: Bounce,
        }
      )
    } finally {
      setLoadingAction("")
    }
  }

  const stepTitle =
    step === "email"
      ? "Forgot Password"
      : step === "otp"
      ? "Verify OTP"
      : "Reset Password"

  const stepDescription =
    step === "email"
      ? "Enter your registered email address to receive a one-time password."
      : step === "otp"
      ? `Enter the 6-digit OTP sent to ${formVal.email}.`
      : "Set a new password for your admin account."

  return (
    <>
      <section className="main-login">
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-xl-6 b-center bg-size d-none d-lg-block d-xl-block"
              style={{
                backgroundImage: "url(/Pilogin.png)",
                backgroundSize: "cover",
                backgroundPosition: "center center",
                display: "block",
              }}
            >
              <div className="login-lft">
                <img src="/Pidigihub_Logo.png" alt="Pidigihub" />
              </div>
            </div>

            <div className="col-xl-6 p-0">
              <div className="login-card">
                <form
                  onSubmit={
                    step === "email"
                      ? sendOtp
                      : step === "otp"
                      ? verifyOtp
                      : resetPassword
                  }
                  className="login-form"
                >
                  <h4>
                    <span>{stepTitle}</span>
                  </h4>
                  <p className="text-muted mb-4">{stepDescription}</p>

                  <div className="mb-4 frm-bx">
                    <label className="form-label">Email Address</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      onChange={changeHandler}
                      placeholder="Enter registered email"
                      value={formVal.email}
                      disabled={step !== "email"}
                    />
                    <span className="fa fa-envelope" />
                  </div>

                  {step !== "email" && (
                    <div className="text-end mb-3">
                      <button
                        type="button"
                        className="btn btn-link p-0 text-decoration-none"
                        onClick={() => {
                          setStep("email")
                          setFormVal((prev) => ({
                            ...prev,
                            otp: "",
                            newPassword: "",
                            confirmPassword: "",
                          }))
                        }}
                      >
                        Change Email
                      </button>
                    </div>
                  )}

                  {step === "otp" && (
                    <>
                      <div className="mb-4 frm-bx">
                        <label className="form-label">OTP</label>
                        <input
                          type="text"
                          className="form-control"
                          name="otp"
                          onChange={changeHandler}
                          placeholder="Enter 6-digit OTP"
                          value={formVal.otp}
                          maxLength={6}
                        />
                        <span className="fa fa-shield" />
                      </div>

                      <div className="text-end mb-3">
                        <button
                          type="button"
                          className="btn btn-link p-0 text-decoration-none"
                          onClick={(event) => sendOtp(event, true)}
                          disabled={loadingAction === "resend"}
                        >
                          {loadingAction === "resend" ? "Resending..." : "Resend OTP"}
                        </button>
                      </div>
                    </>
                  )}

                  {step === "reset" && (
                    <>
                      <div className="mb-4 frm-bx">
                        <label className="form-label">New Password</label>
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          name="newPassword"
                          onChange={changeHandler}
                          placeholder="Enter new password"
                          value={formVal.newPassword}
                        />
                        {showPassword ? (
                          <span
                            className="fa fa-eye-slash"
                            onClick={() => setShowPassword(false)}
                          />
                        ) : (
                          <span
                            className="fa fa-eye"
                            onClick={() => setShowPassword(true)}
                          />
                        )}
                      </div>

                      <div className="mb-4 frm-bx">
                        <label className="form-label">Confirm Password</label>
                        <input
                          type={showConfirmPassword ? "text" : "password"}
                          className="form-control"
                          name="confirmPassword"
                          onChange={changeHandler}
                          placeholder="Confirm new password"
                          value={formVal.confirmPassword}
                        />
                        {showConfirmPassword ? (
                          <span
                            className="fa fa-eye-slash"
                            onClick={() => setShowConfirmPassword(false)}
                          />
                        ) : (
                          <span
                            className="fa fa-eye"
                            onClick={() => setShowConfirmPassword(true)}
                          />
                        )}
                      </div>
                    </>
                  )}

                  <div className="mb-4 mt-4 frm-bx">
                    <button
                      className="frm-btn w-100"
                      type="submit"
                      disabled={Boolean(loadingAction)}
                    >
                      {loadingAction ? (
                        <div className="btn-loader-a">
                          <svg
                            className="spinner-a"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="spinner-track"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="spinner-path"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.4 0 0 5.4 0 12h4z"
                            ></path>
                          </svg>
                        </div>
                      ) : step === "email" ? (
                        "Send OTP"
                      ) : step === "otp" ? (
                        "Verify OTP"
                      ) : (
                        "Reset Password"
                      )}
                    </button>
                  </div>

                  <div className="text-center">
                    <Link to="/login" className="text-decoration-none">
                      Back to Login
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .btn-loader-a {
          display: inline-flex;
          align-items: center;
          gap: 6px;
        }

        .spinner-a {
          width: 20px;
          height: 20px;
          animation: spin 0.7s linear infinite;
          color: #ffffff;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        .spinner-track {
          opacity: 0.25;
        }

        .spinner-path {
          opacity: 0.75;
        }
      `}</style>
    </>
  )
}
